import { render } from "./DeleteUser.vue?vue&type=template&id=92f56b80&scoped=true&ts=true"
import script from "./DeleteUser.vue?vue&type=script&lang=ts"
export * from "./DeleteUser.vue?vue&type=script&lang=ts"

import "./DeleteUser.vue?vue&type=style&index=0&id=92f56b80&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f56b80"]])

export default __exports__